import { useFormikContext } from 'formik';

import { ErrorField } from '@/components/error-field';
import { RequiredLabel } from '@/components/required-label';
import { Button } from '@/components/ui/button';
import { DialogDescription, DialogFooter, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Field } from '@/components/ui/field';
import { Input } from '@/components/ui/input';

import type { ApiKeyCreateFormValues } from '@/schemas/api-key.schema';

import { useFormikError } from '@/lib/error';

type Props = {
  isLoading: boolean;
  toggle: () => void;
};

export const ApiKeyCreateForm = ({ isLoading, toggle }: Props) => {
  const { getFieldProps, isValid } = useFormikContext<ApiKeyCreateFormValues>();
  const hasError = useFormikError();

  return (
    <>
      <DialogHeader>
        <DialogTitle className="text-lg font-semibold">Add an API Key</DialogTitle>
        <DialogDescription className="text-sm text-muted-foreground">
          Add a new API key to registered applications to allow them to access your services.
        </DialogDescription>
      </DialogHeader>
      <div className="space-y-4 py-4">
        <div className="space-y-2">
          <Field aria-invalid={hasError('secret_name')}>
            <RequiredLabel htmlFor="private-key-name">Key name</RequiredLabel>
            <Input
              id="private-key-name"
              placeholder="e.g. Staging-Frontend-PrivKey"
              aria-invalid={hasError('secret_name')}
              className="h-9"
              {...getFieldProps('secret_name')}
            />
            <ErrorField name="secret_name" />
          </Field>
        </div>
      </div>
      <DialogFooter>
        <Button type="button" variant="outline" onClick={toggle}>
          Cancel
        </Button>
        <Button type="submit" disabled={!isValid || isLoading}>
          Create
        </Button>
      </DialogFooter>
    </>
  );
};
